// extracted by mini-css-extract-plugin
export default {"searchbar":"SearchBar_searchbar__55FZp","searchbarWrapper":"SearchBar_searchbarWrapper__JOZ2W","MuiInputBase-root":"SearchBar_MuiInputBase-root__lL4YA"};